import {DISCUSSION_API, ADD_NEW_COMMENT_ERROR} from '../../../constants';

export const addNewComment = async ({
    discussionId,
    discussionComment,
    userId
}) => {
    try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await fetch(`${DISCUSSION_API}/${discussionId}/comments`, {
            method: 'POST',
            headers: new Headers({
                'x-access-token': user.accessToken,
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                userId,
                content: discussionComment
            })
        });
        if (!response.ok) throw response;
        const responseJson = await response.json();
        return responseJson;
    } catch (error) {
        throw ADD_NEW_COMMENT_ERROR;
    }
};